import React from 'react'
import { Stack } from '@crossfit/ui'
import cx from 'classnames'

import style from './style.module.scss'

type InputProps = {
  errorMessage?: string
  showError: boolean
  children: React.ReactNode
}

const ErrorWrapper = ({ showError, errorMessage, children }: InputProps) => {
  return (
    <Stack
      direction='vertical'
      spacing={2}
      className={cx({ [style.error]: showError })}
    >
      {children}
      {showError && errorMessage && <p>{errorMessage}</p>}
    </Stack>
  )
}

export default ErrorWrapper
